<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <submenu />

        <list class="view__content"
          :data="entries()"
          :fields="headers()"
          :pagination="pagination"
          :hideCreate="false"

          @paginate="paginate"
          @action="action" />
      </div>
    </article>
  </article>
</template>

<script>
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import List from 'components/layout/list'
import Submenu from 'components/views/membership/Submenu'
import listHelpers from 'mixins/list-helpers'

export default {
  name: 'taxes',
  components: { Submenu, List },
  mixins: [listHelpers],
  data() {
    return {
      L: L,
      title: L.localize('Membership_Breadcrumb_Taxes')
    }
  },
  beforeCreate() {
    this.$store.dispatch('getTaxes')
  },
  computed: {
    ...mapGetters({
      taxes: 'allTaxes',
      pagination: 'allTaxesPagination'
    })
  },
  methods: {
    paginate(pageNumber) {
      this.$store.dispatch('getTaxes', {
        page: pageNumber
      })
    },
    action(command) {
      switch (command.name) {
        case 'detail':
          this.$router.push({name: 'tax', params: { id: command.item.id }})
          break;
        case 'create':
          this.$router.push({name: 'tax-create'})
          break;
      }
    },
    entries: function() {
      return this.taxes
    },
    headers: function() {
      let headers = [
        { prop: 'name', label: L.localize('Membership_PaymentOptions_Name') },
        { prop: 'amount', label: L.localize('Membership_PaymentOptions_Amount'), transform: this.showMoney }
      ]
      return headers
    }
  }
}
</script>



// WEBPACK FOOTER //
// Taxes.vue?c21bebce